// import { Box, Container, Text } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
// import { useTranslation } from "react-i18next"
// import useAuth from "../../hooks/useAuth"

import { MyScheduleCalendar } from "../../components/WorkSchedule/MySchedule"

export const Route = createFileRoute("/_layout/work-schedule")({
    component: MyScheduleCalendar,
})